import { Star } from "lucide-react";
import { FadeUp } from "../site/Reveal";

export const Reviews = () => (
  <section className="bg-ivory py-24 md:py-32" data-testid="reviews-section">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      <FadeUp className="grid gap-10 border-y border-line py-14 md:grid-cols-12 md:items-center">
        <div className="md:col-span-5">
          <p className="label-mono">Customer reviews</p>
          <h2 className="mt-4 font-display text-4xl font-light text-ink md:text-5xl">Real words, <em>coming soon.</em></h2>
        </div>
        <div className="md:col-span-7" data-testid="reviews-empty-state">
          <div className="flex gap-1 text-ink">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-5 w-5" strokeWidth={1.2} />)}</div>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-graphite">
            We only publish genuine reviews from verified MARKHOR customers. This section will fill automatically once the first reviews arrive.
          </p>
          <a href="#newsletter" className="link-line mt-6 inline-block text-xs uppercase tracking-[0.2em] text-ink" data-testid="reviews-notify-link">Get notified</a>
        </div>
      </FadeUp>
    </div>
  </section>
);
